var map = {
	"./calculator.svg": 283,
	"./excel.svg": 284,
	"./exception_frame.png": 285,
	"./exception_frame.svg": 286,
	"./no_calculator.svg": 287,
	"./no_disconnect.svg": 288,
	"./no_headphones.svg": 289,
	"./no_instant_messaging.svg": 290,
	"./no_internet_browsing.svg": 291,
	"./no_leaving_camera.svg": 292,
	"./no_local_browsing.svg": 293,
	"./no_materials.svg": 294,
	"./no_pause.svg": 295,
	"./no_people_in_room.svg": 296,
	"./no_phone.svg": 297,
	"./no_tv_radio.svg": 298,
	"./notes.svg": 299,
	"./pdf.svg": 300,
	"./people_with_interaction.svg": 301,
	"./people_without_interaction.svg": 302,
	"./powerpoint.svg": 303,
	"./rule_frame.png": 304,
	"./rule_frame.svg": 305,
	"./specific_websites.svg": 306,
	"./textbooks.svg": 307,
	"./word.svg": 308
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 282;